/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Životní cyklus ovladače pro zobrazování médií.
 * Pomocná třída pro kontrolu správné posloupnosti volání metod.
 *
 * ![Diagram stavového automatu](./core/viewer/life-cycle/viewer-life-cycle.doc.png)
 */
class ViewerLifeCycle {
  /**
   * Vytvoří instanci.
   * @param {StateMachineFactory} stateMachineFactory
   * @returns {ViewerLifeCycle} Nová instance.
   */
  constructor(stateMachineFactory) {
    /**
     * Stavový automat životního cyklu.
     * @private
     * @type {StateMachine}
     */
    this.stateMachine = stateMachineFactory.create({
      init: 'created',
      transitions: [
        { name: 'enter', from: 'seized', to: 'entered' },
        { name: 'leave', from: 'entered', to: 'left' },
        { name: 'release', from: ['left', 'seized'], to: 'released' },
        { name: 'seize', from: 'created', to: 'seized' }
      ]
    });
  }

  /**
   * Zahájí zobrazení média a jeho přehrávání.
   * @param {Function} cb Async operace, které se provádějí při zobrazení.
   * @returns {Promise.<*>} Výsledek operací při zobrazení.
   */
  enter(cb) {
    return this.stateMachine.transitAsync('enter', cb);
  }

  /**
   * Zahájí skrytí média a ukončení jeho přehrávání.
   * @param {Function} cb Async operace, které se provádějí při skrytí.
   * @returns {Promise.<*>} Výsledek operací při skrytí.
   */
  leave(cb) {
    return this.stateMachine.transitAsync('leave', cb);
  }

  /**
   * Uvolní sdílený element k dalšímu použití.
   * @param {Function} cb Async operace, které se provádějí při uvolnění.
   * @returns {Promise.<*>} Výsledek operací při uvolnění.
   */
  release(cb) {
    return this.stateMachine.transitAsync('release', cb);
  }

  /**
   * Převezme kontrolu nad sdíleným elementem.
   * @param {Function} cb Async operace, které se provádějí při přebírání.
   * @returns {Promise.<*>} Výsledek operací při přebírání.
   */
  seize(cb) {
    return this.stateMachine.transitAsync('seize', cb);
  }
}

export default ViewerLifeCycle;
